import { schemes, zSchema } from "@zeal/common";

export const postPartnerUBODocumentFromPersonaParamsSchema = zSchema.object({
  whiteLabelID: schemes.uuid(),
  persona_inquiry_id: zSchema.string(),
  first_name: zSchema.string(),
  last_name: zSchema.string(),
});

export type TPostPartnerUBODocumentFromPersonaParams = zSchema.infer<
  typeof postPartnerUBODocumentFromPersonaParamsSchema
>;

export const postPartnerUBODocumentFromPersonaResponseSchema = zSchema.object({
  success: zSchema.boolean(),
  message: zSchema.string(),
});

export type TPostPartnerUBODocumentFromPersonaResponse = zSchema.infer<
  typeof postPartnerUBODocumentFromPersonaResponseSchema
>;
